import {LANGUAGE_DETAIL} from '../constants/LanguageDetails';

const initialState = {};

const languageReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case LANGUAGE_DETAIL:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};
export default languageReducer;
